import axios from 'axios';

import { youkuClientId } from '../../common/constants/youku-client-id';
import { VideoThumbnail } from '../models/video-thumbnail';
import { YoukuResponse } from '../models/youku-response';

export const getVideoThumbnail = async (
  videoId: string,
  isYoukuVideo: boolean
): Promise<VideoThumbnail | undefined> => {
  if (!videoId) {
    throw new Error('Video ID is required');
  }

  if (isYoukuVideo) {
    const url = `https://api.youku.com/videos/show.json?client_id=${youkuClientId}&video_id=${videoId}`;
    try {
      const response = await axios.get<YoukuResponse>(url);
      if (response.data.error) {
        throw new Error(`Youku API error: ${response.data.error.code}`);
      }
      return { url: response.data.bigThumbnail } as VideoThumbnail;
    } catch (error) {
      console.error('Error fetching Youku video thumbnail:', error);
      return undefined;
    }
  } else {
    return new Promise((resolve) => {
      resolve({ url: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` } as VideoThumbnail);
    });
  }
};
